import { createApi } from '@reduxjs/toolkit/query/react';
import axiosFetchBase from '../axiosFetchBase.js';
import { urls } from '../../utils/helpers/ApiClient.jsx';

export const searchHistoryApi = createApi({
  reducerPath: 'searchHistoryApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getSearchHistory: builder.query({
      query: (params = {}) => ({
        url: urls.searchHistory,
        params,
      }),
    }),
    getSearchHistoryCsv: builder.query({
      query: () => ({
        url: urls.searchHistoryCsv,
      }),
    }),
  }),
});

export const { useGetSearchHistoryQuery, useLazyGetSearchHistoryCsvQuery } =
  searchHistoryApi;
